var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 277,
    viewBox: "0 0 512 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.4893 93.7902C78.4893 194.806 160.378 276.696 261.394 276.696H329.094C430.11 276.696 511.999 194.806 511.999 93.7902H78.4893V93.7902Z",
    fill: "#7D868C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M475.481 93.7901C455.082 172.54 383.541 230.697 298.411 230.697H230.711C177.178 230.697 129.018 207.696 95.5693 171.039C124.69 233.444 187.986 276.695 261.394 276.695H329.094C430.11 276.695 511.999 194.805 511.999 93.7889H475.481V93.7901Z",
    fill: "#C3C6C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M381.939 185.777C394.788 185.777 405.205 175.36 405.205 162.51C405.205 149.661 394.788 139.244 381.939 139.244C369.089 139.244 358.672 149.661 358.672 162.51C358.672 175.36 369.089 185.777 381.939 185.777Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M381.937 174.143C388.362 174.143 393.57 168.935 393.57 162.51C393.57 156.086 388.362 150.878 381.937 150.878C375.513 150.878 370.305 156.086 370.305 162.51C370.305 168.935 375.513 174.143 381.937 174.143Z",
    fill: "#375D9D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M354.106 93.7902C354.106 99.5667 358.789 104.25 364.567 104.25C370.343 104.25 375.027 99.5679 375.027 93.7902H354.106Z",
    fill: "#5C6670"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.818 0H0V37.1362C0 68.4245 25.3644 93.7889 56.6528 93.7889H78.4893V60.6701C78.4893 27.1641 51.3252 0 17.818 0Z",
    fill: "#5C6670"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6528 93.7902C25.3644 93.7902 0 119.155 0 150.443V187.58H17.818C51.3252 187.58 78.4893 160.416 78.4893 126.909V93.7902H56.6528Z",
    fill: "#5C6670"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M270.991 174.143C237.482 174.143 210.319 201.306 210.319 234.814V252.632H225.62C268.968 252.632 304.109 217.492 304.109 174.143H270.991V174.143Z",
    fill: "#5C6670"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhale);
export default __webpack_public_path__ + "static/media/whale.b165dd65dd9c563e22fd107aa69966dd.svg";
export { ForwardRef as ReactComponent };